export default __webpack_public_path__ + "static/media/Repressor's Codex.51ad3ce2.jpg";